import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import i18n from './i18n/config'; // Importe l'instance i18n configurée
import { I18nextProvider } from 'react-i18next'; // Importe le fournisseur de traduction
import { AuthProvider } from './contexts/AuthContext'; // Importe le fournisseur d'authentification

// Gestionnaire global d'erreur pour supprimer les erreurs ResizeObserver non critiques
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    // Ignore cette erreur spécifique car elle est non critique
    return;
  }
  originalError.apply(console, args);
};

// Gestionnaire d'erreur pour les erreurs non capturées
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    event.preventDefault();
    return;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}> {/* Enveloppe l'application avec le fournisseur i18n */}
      <AuthProvider> {/* Enveloppe l'application avec le fournisseur d'authentification */}
      <App />
      </AuthProvider>
    </I18nextProvider>
  </React.StrictMode>
);

// Si vous voulez commencer à mesurer les performances dans votre application, passez une fonction
// pour journaliser les résultats (par exemple, reportWebVitals)
// reportWebVitals(); // Commenté ou supprimé
